import moment from 'moment';

export default (milliseconds) => {
  const duration = moment.duration(+milliseconds, 'milliseconds');
  return `${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
};
